import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {saveAs} from 'file-saver';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileUtilityService {

  constructor(private http:HttpClient) { }
  downloadFile(base64str: string, contentType: string, fileName: string): any{
    let byteCharacters:any = atob(base64str);
    let byteNumbers:any = new Array(byteCharacters.length);
    for(let i: any=0; i< byteCharacters.length; i++){
    byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    let byteArray:any =new Uint8Array(byteNumbers);
    let blob: any= new Blob([byteArray]);
    saveAs(blob, fileName);
    }

    postFile(fileToUpload: File) {
      const endpoint = 'your-destination-url';
      const formData: FormData = new FormData();
      formData.append('fileKey', fileToUpload, fileToUpload.name);
     // return true;
      // return this.http
      //   .post(endpoint, formData, { headers: yourHeadersConfig })
      //   .map(() => { return true; })
      //   .catch((e) => this.handleError(e));
  }
  // createContrat(fileToUpload: File, newContrat: Contrat): Observable<boolean> {  
  //   let headers = new Headers(); 
  //      const endpoint = Api.getUrl(Api.URLS.createContrat));  
  //        const formData: FormData =new FormData();   
  //         formData.append('fileKey', fileToUpload, FileToUpload.name);  
  //           let body newContrat.gup(this.auth.getCurrentUser().token);    
  //            return this.http.post(endpoint, formData, body).map(() => {        return true;      })  }
}
